import React, { FC, Fragment } from "react";

import "./RichText.css";

interface Props {
  content: {
    html: string;
  };
  descriptionColor?: string;
}
const RichText: FC<Props> = ({ content, descriptionColor }) => {
  return <div style={{ color: descriptionColor }} className="rich-text" dangerouslySetInnerHTML={{ __html: content.html }} />;
};
export default RichText;
